import React, { FC } from "react"
import { Game } from "@smerf-gaming/types"
import { useGameRoles } from "./hooks"
import { addUserHiddenGameRole, removeUserHiddenGameRole } from "../../../../actions"
import { RolesModal } from "../role-modal"

interface GameRolesModalProps {
  listItem: Game | null
  fetchData: () => void
  hideModal: () => void
}

export const GameRolesModal: FC<GameRolesModalProps> = ({ listItem, hideModal, fetchData }) => {
  return (
    <RolesModal
      listItem={listItem}
      hideModal={hideModal}
      fetchData={fetchData}
      getRolesHook={useGameRoles}
      addUserRole={addUserHiddenGameRole}
      removeUserRole={removeUserHiddenGameRole}
      roleOptions={["viewer"]}
    />
  )
}
